import { render, staticRenderFns } from "./FunnelChartSchool.vue?vue&type=template&id=760c4945&scoped=true&"
import script from "./FunnelChartSchool.vue?vue&type=script&lang=js&"
export * from "./FunnelChartSchool.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChartSchool.vue?vue&type=style&index=0&id=760c4945&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c4945",
  null
  
)

export default component.exports